import { Controller } from "@hotwired/stimulus"

// Generic click-to-toggle dropdown (profile switcher, user menu). Closes on
// outside click, on Escape, and keeps `aria-expanded` in sync.
export default class extends Controller {
  static targets = ["panel", "button"];

  connect() {
    this.outsideClickHandler = this.closeIfOutside.bind(this);
    this.keydownHandler = this.closeOnEscape.bind(this);
    document.addEventListener("click", this.outsideClickHandler);
    document.addEventListener("keydown", this.keydownHandler);
  }

  disconnect() {
    document.removeEventListener("click", this.outsideClickHandler);
    document.removeEventListener("keydown", this.keydownHandler);
  }

  // Deliberately does NOT stopPropagation: the click has to reach the document listener so
  // every OTHER open dropdown closes itself (closeIfOutside skips this one, the target is
  // inside it). Swallowing the event left two panels open at once.
  toggle() {
    const isHidden = this.panelTarget.classList.toggle("hidden");
    this.buttonTarget.setAttribute("aria-expanded", (!isHidden).toString());
  }

  close() {
    this.panelTarget.classList.add("hidden");
    this.buttonTarget.setAttribute("aria-expanded", "false");
  }

  closeIfOutside(event) {
    if (!this.element.contains(event.target)) this.close();
  }

  closeOnEscape(event) {
    if (event.key === "Escape") this.close();
  }
}
